import { useState } from "react";
import axios from "axios";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { API, ax, errorText } from "./common";

// Platform administrators set a new password for a tenant administrator; the tenant admin's sessions end.
export default function ResetPasswordDialog({ admin, tenantId, onClose, showMsg }) {
  const { t } = useLang();
  const [password, setPassword] = useState("");

  const close = () => { setPassword(""); onClose(); };

  const submit = async () => {
    try {
      await axios.post(`${API}/tenants/${tenantId}/admins/${admin.id}/reset-password`, { password }, ax);
      showMsg("success", t("adm.us.password_reset"));
      close();
    } catch (e) { showMsg("error", errorText(e, t("adm.error"))); }
  };

  return (
    <Dialog open={!!admin} onOpenChange={(open) => !open && close()}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>{t("adm.us.reset_password")}</DialogTitle></DialogHeader>
        {admin && (
          <div className="space-y-3">
            <p className="text-sm text-slate-600">{admin.name} · {admin.email}</p>
            <div className="space-y-1.5">
              <Label>{t("adm.us.new_password")} *</Label>
              <Input type="password" autoComplete="new-password" value={password}
                onChange={e => setPassword(e.target.value)} className="h-10" />
            </div>
            <p className="text-xs text-slate-500">{t("adm.us.password_min")}</p>
            <p className="text-xs text-slate-500">{t("adm.us.reset_hint")}</p>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={close}>{t("common.cancel")}</Button>
          <Button onClick={submit} disabled={!password} className="bg-blue-600 hover:bg-blue-700">{t("common.save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
